import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InfoDialogueComponent } from '../infodialog/infodialog.component';
import * as XLSX from 'xlsx';
import { ProxyType, LoginType } from 'src/app/helper/constants';
import { IUser, IPayload } from 'src/app/models/user';
import { MsalService } from '@azure/msal-angular';
import { TranslocoService } from '@ngneat/transloco';
import { LoginTypeSelector } from 'src/app/app-store/login/login.selector';
import { select, Store } from '@ngrx/store';
import { userDetailsPayload } from 'src/app/app-store/user/user.selector';
// import { MsalService } from 'src/app/msal/services/msal.service';

@Component({
  selector: 'app-upload-exceldialog',
  templateUrl: './upload-exceldialog.component.html',
  styleUrls: ['./upload-exceldialog.component.css']
})

export class UploadExceldialogComponent implements OnInit {

  Uploadform: FormGroup;
  totalPeopleAdded: string;
  type: any[];
  earseIcon: boolean;
  fileName = this.translocoService.translate('no_file_chosen');
  fileobj: string;
  currentUser: boolean;
  useralredyinlist: boolean;
  validateRegex: boolean;
  selectedTab: string;
  excelUserList: IUser[] = [];
  showexcelerror: boolean;
  isExternalloginType: boolean;
  userDetails: IPayload;

  constructor(private router: Router,
              public dialogRef: MatDialogRef<UploadExceldialogComponent>
    ,         private infoDialog: MatDialog
    ,         private viewRef: ViewContainerRef
    ,         private authService: MsalService
    ,         private translocoService: TranslocoService
    ,         private fb: FormBuilder
    ,         private store: Store) {
  }

  onNoClick(): void {
    this.excelUserList = [];
    this.dialogRef.close();
  }
  ngOnInit() {
    this.initForm();

    this.store.pipe(select(LoginTypeSelector)).subscribe(response => {
      if (response === LoginType.External_User) {
        this.isExternalloginType = true;
      } else {
        this.isExternalloginType = false;
      }
    });

    this.store.pipe(select(userDetailsPayload)).subscribe(response => {
      if (response !== undefined) {
        this.userDetails = response;
      }
    });

  }

  initForm() {
    this.Uploadform = this.fb.group({
      fileobj: [null]
    });
  }

  // Upload -Excel Start
  erase() {
    this.fileName = this.translocoService.translate('no_file_chosen');
    this.earseIcon = false;

    this.Uploadform.controls.fileobj.setValue('');
  }

  delete = (index) => {
    this.excelUserList.splice(index, 1);
    this.setTotalNumer();
  }

  openerroDialog(message): void {
    const dialogRef = this.infoDialog.open(InfoDialogueComponent, {
      minWidth: '30vw',
      data: { status: message },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      dialogRef.close();
    });
  }

  openInfoDialog(message, beOnSamePage): void {
    const dialogRef = this.infoDialog.open(InfoDialogueComponent, {
      minWidth: '30vw',
      data: { status: message, isValid: undefined },
      disableClose: true,
      viewContainerRef: this.viewRef
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!beOnSamePage) {
        this.selectedTab = ProxyType.Individual;
      }
      dialogRef.close();
    });
  }

  uploadFile(evt: any) {

    // const reader = new FileReader(); // HTML5 FileReader API
    const file = evt.target.files[0];
    const pattern = '.xlsx';
    if (file.name.substr(file.name.lastIndexOf('.')) !== pattern) {
      this.openerroDialog(this.translocoService.translate('invalid_format'));
      return;
    }

    /* wire up file reader */
    const target: DataTransfer = (evt.target) as DataTransfer;
    if (target.files.length !== 1) { throw new Error(this.translocoService.translate('cannot_use_multiple_files')); }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.type = XLSX.utils.sheet_to_json(ws, { header: 1 });


      this.fileName = file.name;
      this.earseIcon = true;

      const listtocompare = ['Name', 'JobTitle', 'AreaCode', 'Contact Number', 'Company', 'Email', 'GIN/ID'];
      const is_samelist = this.type[0];
      const is_same = (listtocompare.length == is_samelist.length) && listtocompare.every(function(element, index) {
        return element === is_samelist[index];
      });
      // console.log(JSON.stringify(this.type));
      if (is_same) {
        const nameregex = new RegExp('^([a-zA-Z0-9][a-zA-Z0-9]?[a-zA-Z0-9]?)+$');
        const areaCoderegex = new RegExp('^[0-9]{1,6}$');
        const mobilePhoneregex = new RegExp('^[0-9]{5,15}$');
        const emailregex = new RegExp('(.+)@(.+){2,}\.(.+){2,}');
        const ginregex = new RegExp('^[0-9a-zA-Z]{0,20}$');

        const finallist = this.type.filter(item => item.length != 0).slice(1);

        this.validateRegex = finallist.every(item => (
          nameregex.test(item[0].replace(/ +/g, '')) &&
          nameregex.test(item[1].replace(/ +/g, '')) &&
          areaCoderegex.test(item[2]) &&
          mobilePhoneregex.test(item[3]) &&
          nameregex.test(item[4].replace(/ +/g, '')) &&
          (item[5] === undefined ? true : emailregex.test(item[5].replace(/ +/g, ''))) &&
          (item[6] === undefined ? true : ginregex.test(item[6]))
        ));

        if (this.validateRegex) {
          this.showexcelerror = false;
          const result: IUser[] = finallist.map(item => ({
            displayName: item[0],
            jobTitle: item[1],
            mobilePhone: String('+' + item[2] + ' ' + item[3]),
            company: item[4],
            userPrincipalName: item[5] === undefined ? null : item[5],
            extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber: item[6] === undefined ? '' : String('0' + item[6])
          }));
          result.map(item => {
            if (this.isExternalloginType) {
              if (item.userPrincipalName !== this.userDetails.email) {
                if (this.excelUserList.map(e => e.email).indexOf(item.email) === -1) {
                  this.excelUserList.push(item);
                  this.setTotalNumer();
                } else {
                  this.useralredyinlist = true;
                }
              } else {
                this.currentUser = true;
              }
            } else {
              if (!item.userPrincipalName || item.userPrincipalName.toLocaleLowerCase() !== this.authService.instance.getAllAccounts()[0]?.username?.split('@')[0].toLocaleLowerCase()) {
                if (this.excelUserList.map(e => e.mobilePhone).indexOf(item.mobilePhone) === -1) {
                  this.excelUserList.push(item);
                  this.setTotalNumer();
                } else {
                  this.useralredyinlist = true;
                }
              } else {
                this.currentUser = true;
              }
            }
          });

          if (this.currentUser) {
            this.openInfoDialog(this.translocoService.translate('you_cannot_proxy_check_in_yourself'), true);
            this.currentUser = false;
            this.useralredyinlist = false;
          }
          if (this.useralredyinlist) {
            this.openInfoDialog(this.translocoService.translate('duplicate_user_cannot_be_added_to_the_list'), true);
            this.useralredyinlist = false;
          }

          // console.log(result);
        } else {
          this.showexcelerror = true;
          this.excelUserList = [];
          this.erase();
        }
      } else {
        this.openInfoDialog(this.translocoService.translate('please_use_mentioned_template_or_download_it'), true);
        this.erase();
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  setTotalNumer = () => {
    this.totalPeopleAdded = this.excelUserList.length + ' ' + this.translocoService.translate('people_added');
  }
  // Upload -Excel End


  onAdd() {
    this.dialogRef.close(this.excelUserList);
  }


  onCancel() {
    this.dialogRef.close();
  }

}
